angular
    .module('clickbooth-common')
    .service('successfullyAddedDevice', ['$rootScope', '$modal', '$state', 'config', function($rootScope, $modal, $state, config) {
        var scope = $rootScope.$new(true);
        var modal = $modal({
            scope: scope,
            controllerAs: 'ctrl',
            template: `<div class="modal successfully-added-device" tabindex="-1" role="dialog">
                            <div class="modal-dialog style="max-width: 100%; height: 100%; margin: 0 auto">
                                <div class="modal-content style="height: 100%"">
                                    <div class="modal-body">
                                        <div class="alert-icon success-icon" style="display: flex; align-items: center; justify-content: center;">
                                            <i class="ti-check" style="font-weight: bold; font-size: 26px; line-height: 1px;"></i>
                                        </div>
                    
                                        <h1 style="color: #3FDE7F">Success!</h1>
                    
                                        <p>The new device has been added to your account to <br/> 
                                            use for additional security verification.
                                        </p>
                                        
                                        <span style="display: block; text-align: center; font-size: 12px;">You will automatically be redirected to your <br/> 
                                                dashboard in 3 seconds, if not click 
                                            <a ng-href="{{link}}" id="authoriser">here.</a>
                                        </span>
                    
                                    </div>
                                </div>
                            </div>
                        </div>`,
            backdrop: 'static',
            show: false
        });

    
        return {
            show: function(options) {
                scope.modalOptions = options;
                modal.$promise.then(modal.show);
                
            },
            hide: function() {
                modal.hide();
            },
            link: function(url) {
                // console.log(url);
                scope.link = url;
            }
        };

    }]);